<template>
  <div
    v-if="value"
    v-loading="loading"
    class="tournament-light-grey rounded pa-4"
    style="height: 212px"
    element-loading-text="Carregando..."
  >
    <!-- First Coach name -->
    <div v-if="value.mainCoach && value.mainCoach.name" class="mb-4">
      <div class="row body-1 tournament-dark-blue--text mb-2">
Técnico
</div>
      <div
        class="row rounded tournament-dark-grey--text pl-2 align-center"
        style="height: 36px; background-color: #ebeff4; cursor: pointer"
        @click="editUser(value.mainCoach)"
      >
        {{ value.mainCoach.name }}
      </div>
    </div>

    <!-- Second Coach name -->
    <div v-if="community != 'desafiocovid' && community != 'desafiorelampago'">
      <div class="row body-1 tournament-dark-blue--text mb-2">
        Técnico suplente
      </div>
      <div
        v-if="alternateCoach || !isEditable"
        class="row rounded align-center"
        style="height: 36px; display: flex; justify-content: space-between"
      >
        <div
          class="tournament-dark-grey--text row rounded pl-2 align-center"
          style="
            background-color: #ebeff4;
            height: 100%;
            display: flex;
            flex: 1 1 auto;
          "
        >
          {{ alternateCoach.name }}
        </div>
        <el-button
          style="height: 36px; width: 180px"
          class="ml-4 tournament-red tournament-white--text rounded no-border"
          @click.native="removeAlternateCoach()"
        >
          ALTERAR
        </el-button>
      </div>
      <div v-else-if="isEditable" class="row">
        <div class="column flex">
          <v-combobox
            v-model="value.coach"
            color="tournament-grey"
            class="mt-0 tournament-grey--text"
            placeholder="Adicionar técnico suplente"
            no-data-text="Nada encontrado"
            :loading="loadingUsers"
            :items="users"
            item-text="name"
            return-object
            @input.native="fetch()"
            @focus="fetch()"
          />
        </div>
        <el-button
          v-if="!alternateCoach"
          style="height: 36px; width: 180px"
          class="ml-4 tournament-light-blue tournament-white--text rounded no-border"
          @click.native="createUser()"
        >
          CRIAR
        </el-button>
        <el-button
          v-else
          key="add"
          style="height: 36px; width: 180px"
          icon="el-icon-plus"
          class="ml-4 tournament-green tournament-white--text rounded no-border"
          @click="addCoachInEnrollment(value)"
        >
          Adicionar
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Team from "@/services/Team";
import { mapState } from "vuex";
import UserEditor from "@/components/Users/Editor";

export default {
  name: "EnrollmentSubmitCoach",

  props: {
    value: {
      type: Object,
      default: () => {},
    },
    enrollmentStatus: {
      type: String,
      required: true,
    },
    teamId: {
      type: String,
      default: "",
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      remoteUsers: [],
      loading: true,

      loadingUsers: false,
      searchCoach: null,
      currentAlternateCoach: null,
    };
  },

  computed: {
    ...mapState(["community"]),

    users() {
      return _([])
        .concat(this.remoteUsers || [])
        .concat(_.get(this.value, "coach", null))
        .compact()
        .filter((u) => _.get(this.value, "mainCoach._id", null) != u._id)
        .value();
    },

    alternateCoach() {
      return _.castArray(this.value && this.value.coach)[0];
    },
  },

  created() {
    // Keep safe when parent pass a undefined as prop
    if (!this.value) {
      return this.$emit(
        "input",
        _.defaulstDeep(this.value, {
          coach: [],
          mainCoach: {},
        }),
      );
    }
    this.fetch();
  },

  methods: {
    createUser() {
      this.$dialog(
        {
          width: this.$vuetify.breakpoint.xsOnly ? "95%" : "608px",
          type: "coach",
          teamId: this.teamId,
          enrollmentStatus: this.enrollmentStatus,
          closeOnClickModal: false,
        },
        UserEditor,
      )
        .then((user) => {
          this.addCoachInEnrollment(user);
        })
        .catch(() => {});
    },

    editUser(user) {
      this.$dialog(
        {
          width: this.$vuetify.breakpoint.xsOnly ? "95%" : "608px",
          type: "coach",
          teamId: this.teamId,
          modelId: user._id,
          enrollmentStatus: this.enrollmentStatus,
          closeOnClickModal: false,
        },
        UserEditor,
      )
        .then(() => {})
        .catch(() => {});
    },

    fetch() {
      this.loadingUsers = true;

      Team.members({ roles: "robotics:coach" }).then(
        (users) => {
          this.loading = false;
          this.loadingUsers = false;

          this.remoteUsers = users.data;
        },
        () => {
          this.loadingUsers = false;
          this.loading = false;
        },
      );
    },

    addCoachInEnrollment(user) {
      if (!_.get(user, "_id")) return;

      // Insert the coach in enrollment
      const localValue = _.cloneDeep(this.value);
      localValue.coach = user;

      this.$emit("input", localValue);
    },

    removeAlternateCoach() {
      const localValue = _.cloneDeep(this.value);
      localValue.coach = null;
      this.$emit("input", localValue);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Enrollments/Submit/Coach.vue